<template>
  <form :id="formId" action=""
        @submit.prevent="submitFunction"
        method="post"
        data-axios="silent"
        :class="classes"
  >
    <slot></slot>
  </form>
</template>

<script>
    export default {
        name: "luma-form",
        props: {
            formId: { type: String },
            submitFunction: { type: Function },
            classes: { type: String}
        },
        data () {
            return {
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LumaForm.vue